<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 21.31 23.42"
  >
    <defs>
      <clipPath id="clip-path" transform="translate(0)">
        <rect class="cls-1" width="21.31" height="23.42" />
      </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g class="cls-2">
          <g id="Group_24847" data-name="Group 24847">
            <path
              id="Path_975"
              data-name="Path 975"
              class="cls-3"
              d="M15.67,14.29v5.84H3.28V7.74H9.15l2.71-3.29H3.28A3.28,3.28,0,0,0,0,7.74H0v12.4a3.28,3.28,0,0,0,3.27,3.28h12.4A3.28,3.28,0,0,0,19,20.14h0V10.33Z"
              transform="translate(0)"
            />
            <path
              id="Path_976"
              data-name="Path 976"
              class="cls-3"
              d="M15.66,3.52,8.49,11.85l3.6,2.8,7.17-8.33,1.8,1.4L21.31,0,13.85,2.12Z"
              transform="translate(0)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: none;
}
.cls-2 {
  clip-path: url(#clip-path);
}
.cls-3 {
  fill: #fff;
}
</style>
